import { useMutation } from 'react-query';
import { PlaceholderSettingDto } from '../../../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';

const createPlaceholderManagement = (placeholder: PlaceholderSettingDto) =>
    getProductReservationApi().placeholderSetting.createCreate(placeholder)
        .then((response) => response.data);

const useCreatePlaceholderManagement = () => {
    const useCreatePlaceholderManagementMutation = useMutation(createPlaceholderManagement);

    return useCreatePlaceholderManagementMutation;
};

export default useCreatePlaceholderManagement;
